import { Injectable } from '@angular/core'
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
	UrlTree,
} from '@angular/router'
import { GtmReportAuthService } from '../services/gtm-report-auth/gtm-report-auth.service'

@Injectable({
	providedIn: 'root',
})
export class GtmReportAuthGuard implements CanActivate {
	constructor(private auth: GtmReportAuthService, private router: Router) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean | UrlTree {
		if (this.auth.isLoggedIn()) {
			return true
		}

		const lang = route.parent?.paramMap.get('lang') || 'pt'
		return this.router.createUrlTree([lang, 'relatorio-gtm-login'], {
			queryParams: { returnUrl: state.url },
		})
	}
}
